// @flow
import Trail from './Trail';
import style from './style';
import { useTrailsLayer, TrailsProvider } from './context';

export {
    TrailsProvider,
    useTrailsLayer,
    style
};

export default Trail;